module.exports = __webpack_public_path__ + "img/strava.860daed4.svg";